import { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  getIsBenefitAvailable,
  getIsBenefitEventActive,
  getStoreCode
} from "../../../state/modules/config/selectors";
import styles from "./index.css";
import BannerContent from "./BannerContent";
import shouldEnableBanner from "./shouldEnableBanner";
import { getCategoryId } from "../../../state/modules/category";
import { EARLY_ACCESS_SALE } from "../../../state/modules/config/constants";

const LoyaltyEarlyAccessSaleBanner = () => {
  const categoryId = useSelector(getCategoryId);
  const isBenefitAvailable = useSelector(getIsBenefitAvailable);
  const isBenefitEventActive = useSelector(getIsBenefitEventActive);
  const storeCode = useSelector(getStoreCode);

  const isEarlyAccessSaleAvailable = isBenefitAvailable
    ? isBenefitAvailable[EARLY_ACCESS_SALE]
    : undefined;
  const isEarlyAccessSaleEventActive = isBenefitEventActive
    ? isBenefitEventActive[EARLY_ACCESS_SALE]
    : undefined;
  const bannerRef = useRef(null);
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    setIsEnabled(
      shouldEnableBanner({
        categoryId,
        isEarlyAccessSaleAvailable,
        isEarlyAccessSaleEventActive,
        storeCode
      })
    );
  }, [isEarlyAccessSaleAvailable, isEarlyAccessSaleEventActive, storeCode]);

  if (!isEnabled) {
    return null;
  }

  return (
    <li className={styles.loyaltyEarlyAccessSaleBanner} ref={bannerRef}>
      <BannerContent />
    </li>
  );
};

export default LoyaltyEarlyAccessSaleBanner;
